import { getErrorMessage } from "@helper/getErrorMessage";
import { reactionCount } from "@helper/utils";
import { HandleReactionClick, ReactionProp } from "@typings/Reactions";
import { type ReactElement, useState } from "react";

import { getReactionGif } from "./helper/getReactionGif";

type ArticleReactionOptionsProps = {
  reactions: ReactionProp[];
  handleReactionClick: HandleReactionClick;
  reactionsUser: string;
  articleId: string;
  variant?: "top" | "bottom";
};

export const ArticleReactionOptions = ({
  reactions,
  handleReactionClick,
  reactionsUser,
  articleId,
  variant = "top",
}: ArticleReactionOptionsProps): ReactElement => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClick = async (
    reactionId: string,
    variant?: "top" | "bottom",
  ) => {
    setIsSubmitting(true);
    try {
      await handleReactionClick(reactionId, variant);
    } catch (err) {
      console.log("Reactions not working", getErrorMessage(err));
    } finally {
      setIsSubmitting(false);
    }
  };

  if (reactions.length === 0) {
    return <></>;
  }

  const isBottomVariant = variant === "bottom";

  const wrapperClass = isBottomVariant
    ? "flex flex-col lg:flex-row gap-3.5 py-4 px-8 justify-center lg:justify-between items-center bg-blue-100"
    : "flex w-max py-3 px-8 justify-center items-center rounded-3xl border-blue-100 border bg-bg-primary";

  const listWrapperClass = `flex items-start ${isBottomVariant ? "gap-8" : "gap-9"}`;

  const unSelectedCountClass = isBottomVariant
    ? "text-text-inverse"
    : "text-neutral-700";

  const selectedCountClass = isBottomVariant
    ? "text-text-inverse !font-bold"
    : "text-brand-primary";

  return (
    <div
      className={wrapperClass}
      style={
        !isBottomVariant
          ? {
              boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.16)",
            }
          : undefined
      }
    >
      {isBottomVariant && (
        <div
          data-testid="reaction-prompt"
          className="text-center lg:text-left text-text-inverse text-sm font-medium leading-[150%]"
        >
          Adakah anda menikmati artikel ini? Beritahu kami.
        </div>
      )}
      <ul className={listWrapperClass}>
        {reactions.map((reaction) => (
          <li key={`reactions-li-${variant}-${reaction.id}-${articleId}`}>
            <button
              disabled={isSubmitting}
              onClick={() => {
                void handleClick(reaction.id, variant);
              }}
              className="flex flex-col justify-center items-center gap-1"
              aria-label={reaction.text}
            >
              <img
                src={getReactionGif(reaction.id)}
                alt={reaction.text}
                width={20}
              />
              <div
                className={`text-center font-medium text-sm leading-[150%]
                  ${reactionsUser === reaction.id ? selectedCountClass : unSelectedCountClass}
                `}
              >
                {reactionCount(reaction.count)}
              </div>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
